import './answer-btn.scss';
import propTypes from 'prop-types';

export default function AnswerBtn(props) {
  return (
    <button
      {...props}
      onClick={props.onClick}
      className={'answer-btn' + (props.selected ? ' selected' : '')}
    >
      {props.children}
    </button>
  );
}

AnswerBtn.propTypes = {
  onClick: propTypes.func,
  selected: propTypes.bool,
  children: propTypes.any
};
